// Code example generators for different languages/libraries

const BASE_URL = 'https://client-api.fluxuro.ai';

// Generate cURL command
export const generateCurl = (endpoint) => {
  const { method, endpoint: path, headers, parameters, body } = endpoint;
  
  let curl = `curl --location '${BASE_URL}${path}`;
  
  // Add query parameters if GET request
  if (method === 'GET' && parameters.length > 0) {
    const queryParams = parameters
      .filter(p => !p.in || p.in !== 'path')
      .map(p => `${p.name}=${p.default || '{' + p.name + '}'}`)
      .join('&');
    if (queryParams) {
      curl = `curl --location '${BASE_URL}${path}?${queryParams}`;
    }
  }
  
  curl += `'`;
  
  // Add headers
  headers.forEach(header => {
    curl += ` \\\n--header '${header.name}: ${header.value}'`;
  });
  
  // Add body for POST requests
  if (body) {
    curl += ` \\\n--data '${JSON.stringify(body, null, 2).replace(/'/g, "'\\''")}'`;
  }
  
  return curl;
};

// Generate Axios code
export const generateAxios = (endpoint) => {
  const { method, endpoint: path, headers, parameters, body } = endpoint;
  
  let code = `import axios from 'axios';\n\n`;
  code += `const response = await axios.${method.toLowerCase()}(\n`;
  code += `  '${BASE_URL}${path}'`;
  
  // Add body for POST requests
  if (body) {
    code += `,\n  ${JSON.stringify(body, null, 2).split('\n').join('\n  ')}`;
  }
  
  // Add config object
  code += `,\n  {\n`;
  
  // Add headers
  if (headers.length > 0) {
    code += `    headers: {\n`;
    headers.forEach(header => {
      code += `      '${header.name}': '${header.value}',\n`;
    });
    code += `    },\n`;
  }
  
  // Add params for GET requests
  if (method === 'GET' && parameters.length > 0) {
    const queryParams = parameters.filter(p => !p.in || p.in !== 'path');
    if (queryParams.length > 0) {
      code += `    params: {\n`;
      queryParams.forEach(param => {
        code += `      ${param.name}: '${param.default || param.name}',\n`;
      });
      code += `    },\n`;
    }
  }
  
  code += `  }\n`;
  code += `);\n\n`;
  code += `console.log(response.data);`;
  
  return code;
};

// Generate Python requests code
export const generatePython = (endpoint) => {
  const { method, endpoint: path, headers, parameters, body } = endpoint;
  
  let code = `import requests\nimport json\n\n`;
  code += `url = "${BASE_URL}${path}"\n\n`;
  
  // Add headers
  if (headers.length > 0) {
    code += `headers = {\n`;
    headers.forEach(header => {
      code += `    "${header.name}": "${header.value}",\n`;
    });
    code += `}\n\n`;
  }
  
  // Add params for GET requests
  if (method === 'GET' && parameters.length > 0) {
    const queryParams = parameters.filter(p => !p.in || p.in !== 'path');
    if (queryParams.length > 0) {
      code += `params = {\n`;
      queryParams.forEach(param => {
        code += `    "${param.name}": "${param.default || param.name}",\n`;
      });
      code += `}\n\n`;
    }
  }
  
  // Add body for POST requests
  if (body) {
    code += `data = ${JSON.stringify(body, null, 4).replace(/"/g, '"').replace(/true/g, 'True').replace(/false/g, 'False').replace(/null/g, 'None')}\n\n`;
  }
  
  // Make the request
  code += `response = requests.${method.toLowerCase()}(\n`;
  code += `    url,\n`;
  
  if (headers.length > 0) {
    code += `    headers=headers,\n`;
  }
  
  if (method === 'GET' && parameters.filter(p => !p.in || p.in !== 'path').length > 0) {
    code += `    params=params,\n`;
  }
  
  if (body) {
    code += `    json=data,\n`;
  }
  
  code += `)\n\n`;
  code += `print(response.json())`;
  
  return code;
};

// Process path parameters
export const processPathParams = (path, pathParams) => {
  let processedPath = path;
  pathParams.forEach(param => {
    processedPath = processedPath.replace(`{${param.name}}`, param.default || `YOUR_${param.name.toUpperCase()}`);
  });
  return processedPath;
};
